import { SvgIcon } from "@mui/material";
import React from "react";

function LogoutIcon(props) {
  return (
    <SvgIcon viewBox="0 0 32 32" {...props}>
      <path d="M6.66668 29.3332C6.31305 29.3332 5.97392 29.1927 5.72387 28.9426C5.47382 28.6926 5.33334 28.3535 5.33334 27.9998V3.99984C5.33334 3.64622 5.47382 3.30708 5.72387 3.05703C5.97392 2.80698 6.31305 2.6665 6.66668 2.6665H25.3333C25.687 2.6665 26.0261 2.80698 26.2762 3.05703C26.5262 3.30708 26.6667 3.64622 26.6667 3.99984V7.99984H24V5.33317H8.00001V26.6665H24V23.9998H26.6667V27.9998C26.6667 28.3535 26.5262 28.6926 26.2762 28.9426C26.0261 29.1927 25.687 29.3332 25.3333 29.3332H6.66668ZM24 21.3332V17.3332H14.6667V14.6665H24V10.6665L30.6667 15.9998L24 21.3332Z" />
    </SvgIcon>
  );
}

export default LogoutIcon;
